var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Left(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.75,
    height: 14,
    viewBox: "0 0 15.75 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #6f6f6f;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-left",
    className: "cls-1",
    d: "M12.382,21.744a.875.875,0,1,0,1.237-1.237L8.987,15.875H20.875a.875.875,0,0,0,0-1.75H8.987l4.631-4.631a.875.875,0,0,0-1.237-1.237L6.257,14.382a.875.875,0,0,0,0,1.237Z",
    transform: "translate(-6 -8)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Left);
export default __webpack_public_path__ + "static/media/icons8-left.aa83a8c84ddab53e5415376c95ff45e6.svg";
export { ForwardRef as ReactComponent };